import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/BeyazEsya.css';
import { FaWhatsapp } from "react-icons/fa";

const BeyazEsya = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (brand, category) => {
    // Türkçe karakterleri URL-friendly hale getir
    const categoryId = category
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    
    navigate(`/${brand}#${categoryId}`);
  };

  const markalar = [
    'Arçelik', 'Beko', 'Bosch', 'Siemens', 'Vestel', 'Samsung', 'LG', 'Philips'
  ];

  return (
    <div className="beyaz-esya">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-content">
            <h1>Beyaz Eşya Koleksiyonumuz</h1>
            <p>Modern teknoloji ve enerji tasarrufu ile donatılmış beyaz eşya çözümleri</p>
          </div>
        </section>

        {/* Categories Grid */}
        <section className="beyaz-esya-categories">
          <div className="container">
            <h2>Beyaz Eşya Koleksiyonumuz</h2>
            <div className="categories-grid">
              <div className="category-card">
                <div className="category-header beko-bg">
                  <div className="category-icon">
                    <img width={120} src='../files/beko-logo.png' alt='Beko Beyaz Eşya'/>
                  </div>
                  <h3>Beko Beyaz Eşya</h3>
                </div>
                <div className="category-content">
                  <p>Modern teknoloji ve enerji verimliliği ile donatılmış beyaz eşya çözümleri</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Buzdolabı')}>
                      <span className="item-icon">❄️</span>
                      <span>Buzdolabı</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Çamaşır Makinesi')}>
                      <span className="item-icon">👕</span>
                      <span>Çamaşır Makinesi</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Bulaşık Makinesi')}>
                      <span className="item-icon">🍽️</span>
                      <span>Bulaşık Makinesi</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Kurutma Makinesi')}>
                      <span className="item-icon">🌪️</span>
                      <span>Kurutma Makinesi</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Televizyon')}>
                      <span className="item-icon">📺</span>
                      <span>Televizyon</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Ankastre')}>
                      <span className="item-icon">🔥</span>
                      <span>Ankastre</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Klima')}>
                      <span className="item-icon">❄️</span>
                      <span>Klima</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('beko-beyaz-esya', 'Küçük Ev Aletleri')}>
                      <span className="item-icon">🏠</span>
                      <span>Küçük Ev Aletleri</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/beko-beyaz-esya" className="button">Detayları Gör →</Link>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="beyaz-esya-features">
          <div className="container">
            <h2>Beyaz Eşya Avantajlarımız</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <h3>Enerji Tasarrufu</h3>
                <p>A+ ve üzeri enerji sınıfı ürünler ile tasarruf sağlayın</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔧</div>
                <h3>Teknik Servis</h3>
                <p>Uzman teknik servis ekibi ile hızlı çözüm</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚚</div>
                <h3>Ücretsiz Teslimat</h3>
                <p>Belirli bölgelerde ücretsiz teslimat hizmeti</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛠️</div>
                <h3>Kurulum Hizmeti</h3>
                <p>Profesyonel kurulum ve montaj hizmeti</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Garanti</h3>
                <p>Tüm ürünlerimiz garanti kapsamındadır</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💳</div>
                <h3>Taksit İmkanı</h3>
                <p>Uygun taksit seçenekleri ile kolay ödeme</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Beyaz Eşya İhtiyaçlarınız İçin Bizimle İletişime Geçin</h2>
              <p>Size en uygun beyaz eşya çözümlerini sunmak için buradayız.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BeyazEsya; 